module.exports = __webpack_public_path__ + "static/img/image1.02a409b.jpg";